module.exports = function getResource(label) {
    let resources = {
        ccProgramName: 'Sephora Credit Card Program',
        backLink: 'Back',
        submitButton: 'Submit Application'
    };

    return resources[label];
};
